import { render, staticRenderFns } from "./subscriptionApplication.vue?vue&type=template&id=2b04a9d2"
import script from "./subscriptionApplication.vue?vue&type=script&lang=js"
export * from "./subscriptionApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports